import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {Bearing} from '@/views/system/bearings/interfaces';
import {EntityModule} from './entities/entityModule';

/*
    Динамический модуль хранилища vuex для Подшипников
*/

const moduleName = 'bearingsStoreModule';

function transformGet(elem: any): Bearing {
  return {
    id: elem.id,
    name: elem.name,
    description: elem.description,
    inner_ring: parseFloat(elem.inner_ring),
    outer_ring: parseFloat(elem.outer_ring),
    roller: parseFloat(elem.roller),
    roller_count: parseInt(elem.roller_count),
    roller_angle: parseFloat(elem.roller_angle),
    cage_frequency: parseFloat(elem.cage_frequency),
    roller_frequency: parseFloat(elem.roller_frequency),
    outer_frequency: parseFloat(elem.outer_frequency),
    inner_frequency: parseFloat(elem.inner_frequency),
  };
}

function transformCreateEdit(elem: any): Bearing {
  return {
    name: elem.name,
    description: elem.description,
    inner_ring: parseFloat(elem.inner_ring),
    outer_ring: parseFloat(elem.outer_ring),
    roller: parseFloat(elem.roller),
    roller_count: parseInt(elem.roller_count),
    roller_angle: parseFloat(elem.roller_angle),
    cage_frequency: parseFloat(elem.cage_frequency),
    roller_frequency: parseFloat(elem.roller_frequency),
    outer_frequency: parseFloat(elem.outer_frequency),
    inner_frequency: parseFloat(elem.inner_frequency),
  };
}

function transformSave(model: Bearing): any {
  return {
    id: model.id,
    name: model.name,
    description: model.description,
    inner_ring: model.inner_ring,
    outer_ring: model.outer_ring,
    roller: model.roller,
    roller_count: model.roller_count,
    roller_angle: model.roller_angle,
    cage_frequency: model.cage_frequency,
    roller_frequency: model.roller_frequency,
    outer_frequency: model.outer_frequency,
    inner_frequency: model.inner_frequency,
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class BearingsStoreModule extends EntityModule {
  protected routeName = 'bearings';

  get all(): Bearing[] {
    return super.all as Bearing[];
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: Bearing}> {
    return super.create(transformCreateEdit) as Promise<{data: Bearing}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: Bearing}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: Bearing}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: Bearing) {
    return super.save(model, transformSave);
  }
}

export default getModule(BearingsStoreModule);
